export default __webpack_public_path__ + "static/media/trans_bone.4aaf87dc.png";